import {ISymbolPosition} from "../../core/reel/ReelInterfaces";
import {TheBorderSymbol, TheBorderSymbolStates} from "../reels/TheBorderSymbol";
import {TheBorderXBombSymbol} from "../reels/TheBorderXBombSymbol";
import {TheBorder} from "../TheBorder";

/**
 * Created by jonas on 2021-02-19.
 */

export class SymbolUtils {

    public static createSymbol(symbolName:string, state:TheBorderSymbolStates, symbolPositionData:ISymbolPosition):TheBorderSymbol {

        if(state == TheBorderSymbolStates.SPIN_IN || state == TheBorderSymbolStates.SPIN_OUT) {
            state = TheBorderSymbolStates.SPIN;
        }

        if(symbolName.indexOf("X_BOMB") > -1) {
            const xBomb: TheBorderSymbol = TheBorder.xBombSymbols.getSymbol().init(state);
            xBomb.symbolName = symbolName;
            return xBomb;
        }

        if(symbolName === "WR") {
            return TheBorder.xNudgeSymbols.getXNudgeSymbol(symbolPositionData).init(state);
        }

        if(symbolName === "X_SPLIT" || symbolName === "X_SPLIT_H") {
            const xSplit: TheBorderSymbol = TheBorder.xSplitSymbols.getXSplitSymbol(symbolPositionData).init(state);
            xSplit.symbolName = symbolName;
            return xSplit;
        }

        if(symbolName === "X_WAYS") {
            return TheBorder.xWaysSymbols.getXWaysSymbol(symbolPositionData).init(state);
        }

        if(symbolName.indexOf("BN") > -1) {
            const scatter: TheBorderSymbol = TheBorder.scatterSymbols.getScatterSymbol(symbolPositionData).init(state);
            scatter.symbolName = symbolName;
            return scatter;
        }

        return TheBorder.symbols.getSymbol(symbolName).init(state);
    }
}